import { createContext, useContext } from 'react'

interface DocletLayout {
  // Whether the page is at least the legacy 48em breakpoint wide
  isWide: boolean
}

export const DocletLayoutContext = createContext<DocletLayout>({ isWide: true })

export const useDocletLayout = () => useContext(DocletLayoutContext)
